export default "__VITE_ASSET__DgIGzhxa__"